import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { CgWebsite } from "react-icons/cg";
import { AiFillGithub } from "react-icons/ai";
import { useLang } from "../../context/LanguageContext";
import { translations } from "../../translations";

function ProjectCards(props) {
  const { lang } = useLang();
  const tr = translations[lang].projects;
  const isGithub = props.linkType === "github";

  return (
    <Card className="project-card-view">
      {props.imgPath ? (
        <Card.Img variant="top" src={props.imgPath} alt="card-img" />
      ) : (
        <div className="card-img-placeholder">
          <AiFillGithub />
        </div>
      )}
      <Card.Body>
        <Card.Title>{props.title}</Card.Title>
        <Button
          variant="primary"
          href={props.demoLink}
          target="_blank"
          rel="noopener noreferrer"
          style={{ marginLeft: "10px" }}
        >
          {isGithub ? (
            <>
              <AiFillGithub /> &nbsp;
              {"GitHub"}
            </>
          ) : (
            <>
              <CgWebsite /> &nbsp;
              {tr.visit}
            </>
          )}
        </Button>

        <Card.Text style={{ textAlign: "justify", marginTop: "20px" }}>
          {props.description}
        </Card.Text>
      </Card.Body>
      {props.stack && (
        <Card.Footer>
          <ul className="p0">
            {props.stack.split(",").map((name) => (
              <li key={name}>
                <p className="flex-none rounded-full bg-blue-600 p-2 text-white">{name}</p>
              </li>
            ))}
          </ul>
        </Card.Footer>
      )}
    </Card>
  );
}
export default ProjectCards;
